import styled from 'styled-components';

export const Search = styled.input`
display: block;
  width: 25%;
  padding: 8px;
  margin-bottom: 8px;
  border: 1px solid #d9b6b6;
  border-radius: 5px;
  background-color: #ffe6e6;
  color: #a85353;
  transition: border-color 0.3s ease-in-out;
  &:hover {
    border-color: #ff7f50;
  }
`
